var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"text-body-2",attrs:{"height":"40","app":"","color":"grey lighten-5"}},[_c('span',[_vm._v(" Designed and Buillt by Boston Project, LLC. ")]),_c('v-spacer'),_c('span',[_vm._v(" Copyright © SIGMA "+_vm._s(new Date().getFullYear())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }